var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avatar",class:_vm.classObject},[(_vm.image)?_c('img',{staticClass:"rounded-circle",attrs:{"src":_vm.image,"alt":"user"}}):_c('div',{staticClass:"avatar-name"},[_c('span',[_vm._v(_vm._s(_vm.initials))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }